export default () => {
  return `<h4 class="page-title">Dashboard</h4>
        <div class="inner-container">
          <div class="chart-wrapper">
            <div class="chart-box">
              <div class="chart-box__title">
                <h5 class="chart-title">Active Users</h5>
              </div>
              <div class="ct-chart ct-golden-section" id="chart1"></div>
              <a href="#/list/all-users" class="button button--outline">View List of users</a>
            </div>
            <div class="chart-box">
              <div class="chart-box__title">
                <h5 class="chart-title">New Accounts</h5>
                <span class="chart-sub-title">From Monday-Sunday</span>
              </div>
              <div class="ct-chart ct-golden-section" id="chart2"></div>
              <a href="#/list/new-users" class="button button--outline">View List of users</a>
            </div>
            <div class="chart-box">
              <div class="chart-box__title">
                <h5 class="chart-title">Unconfirmed Accounts</h5>
              </div>
              <div class="ct-chart ct-golden-section" id="chart3"></div>
              <a href="#/list/unconfirmed-users" class="button button--outline">View List of users</a>
            </div>
            <div class="chart-box">
              <div class="chart-box__title">
                <h5 class="chart-title">Pending Deletions</h5>
                <span class="chart-sub-title">within the next 48 hours</span>
              </div>
              <div class="ct-chart ct-golden-section" id="chart4"></div>
              <a href="#/list/marked-users" class="button button--outline">View List of users</a>
            </div>
          </div>
        </div>`;
};
